module.exports = __webpack_public_path__ + "static/img/certificate1.d628c0fb.png";